import { createContext } from "react";

export interface FeatureFlagContextValue {
  flags: Record<string, boolean>;
  /**
   * Returns the evaluated value of a feature flag.
   * - `true`  → flag is enabled
   * - `false` → flag is explicitly disabled
   * - `undefined` → flag does not exist (treat as default/enabled)
   */
  hasFlag: (key: string) => boolean | undefined;
  isLoading: boolean;
}

export const FeatureFlagContext = createContext<FeatureFlagContextValue>({
  flags: {},
  hasFlag: () => undefined,
  isLoading: true,
});
